import Api from '@/service/api';
import Auth from '@/service/auth';


export default {
  name: 'SignOut',

  props: {
    ticket: {
      type: String,
      default: '',
    },
  },

  mounted() {
    if (this.$store.getters.redirectUri) {
      this.redirectUri = this.$store.getters.redirectUri;
    }

    this.redirectUriName = this.redirectUri ? this.redirectUri : '';
    this.redirectUri = this.redirectUri ? this.redirectUri : '/';
  },


  methods: {
    async onSignOut() {
      try {
        await Api.post({
          url: 'sign-out',
          data: {
            session_id: this.session,
          },
        });
      } catch (error) {
        window.console.log(error);
      }

      this.isAuth = Auth.isAuthenticated();
    },

    setTimer() {
      this.localTimerId = setInterval(
        () => {
          this.timeOut -= 1;

          if (this.timeOut === 0) {
            clearInterval(this.localTimerId);
            const ticket = this.ticket ? `?ticket=${this.ticket}` : '';
            window.location.href = `${this.redirectUri}${ticket}`;
          }
        },
        1000,
      );
    },
  },

  created() {
    this.onSignOut();
    this.timeOut = 2;
    this.setTimer();
  },

  beforeDestroy() {
    clearInterval(this.localTimerId);
  },

  data() {
    return {
      redirectUri: this.redirectUri,
      redirectUriName: this.redirectUriName,
    };
  },
};
